/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { BooleanBaseResponse } from '../models/boolean-base-response';
import { CreateHelpCenterGuideDto } from '../models/create-help-center-guide-dto';
import { CreateHelpCenterSectionDto } from '../models/create-help-center-section-dto';
import { HelpCenterAttachmentDtoBaseResponse } from '../models/help-center-attachment-dto-base-response';
import { HelpCenterAttachmentDtoListBaseResponse } from '../models/help-center-attachment-dto-list-base-response';
import { HelpCenterGuideDtoBaseResponse } from '../models/help-center-guide-dto-base-response';
import { HelpCenterGuideDtoListBaseResponse } from '../models/help-center-guide-dto-list-base-response';
import { HelpCenterGuideDtoPagedResponse } from '../models/help-center-guide-dto-paged-response';
import { HelpCenterSectionDtoBaseResponse } from '../models/help-center-section-dto-base-response';
import { HelpCenterSectionDtoListBaseResponse } from '../models/help-center-section-dto-list-base-response';
import { StringListBaseResponse } from '../models/string-list-base-response';
import { UpdateHelpCenterGuideDto } from '../models/update-help-center-guide-dto';
import { UpdateHelpCenterSectionDto } from '../models/update-help-center-section-dto';

@Injectable({
  providedIn: 'root',
})
export class HelpCenterService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation apiHelpCenterSectionsGet
   */
  static readonly ApiHelpCenterSectionsGetPath = '/api/HelpCenter/sections';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHelpCenterSectionsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiHelpCenterSectionsGet$Plain$Response(params?: {
  }): Observable<StrictHttpResponse<HelpCenterSectionDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, HelpCenterService.ApiHelpCenterSectionsGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<HelpCenterSectionDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiHelpCenterSectionsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiHelpCenterSectionsGet$Plain(params?: {
  }): Observable<HelpCenterSectionDtoListBaseResponse> {

    return this.apiHelpCenterSectionsGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<HelpCenterSectionDtoListBaseResponse>) => r.body as HelpCenterSectionDtoListBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHelpCenterSectionsGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiHelpCenterSectionsGet$Json$Response(params?: {
  }): Observable<StrictHttpResponse<HelpCenterSectionDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, HelpCenterService.ApiHelpCenterSectionsGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<HelpCenterSectionDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiHelpCenterSectionsGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiHelpCenterSectionsGet$Json(params?: {
  }): Observable<HelpCenterSectionDtoListBaseResponse> {

    return this.apiHelpCenterSectionsGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<HelpCenterSectionDtoListBaseResponse>) => r.body as HelpCenterSectionDtoListBaseResponse)
    );
  }

  /**
   * Path part for operation apiHelpCenterSectionsPost
   */
  static readonly ApiHelpCenterSectionsPostPath = '/api/HelpCenter/sections';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHelpCenterSectionsPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiHelpCenterSectionsPost$Plain$Response(params?: {
    body?: CreateHelpCenterSectionDto
  }): Observable<StrictHttpResponse<HelpCenterSectionDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, HelpCenterService.ApiHelpCenterSectionsPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<HelpCenterSectionDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiHelpCenterSectionsPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiHelpCenterSectionsPost$Plain(params?: {
    body?: CreateHelpCenterSectionDto
  }): Observable<HelpCenterSectionDtoBaseResponse> {

    return this.apiHelpCenterSectionsPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<HelpCenterSectionDtoBaseResponse>) => r.body as HelpCenterSectionDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHelpCenterSectionsPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiHelpCenterSectionsPost$Json$Response(params?: {
    body?: CreateHelpCenterSectionDto
  }): Observable<StrictHttpResponse<HelpCenterSectionDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, HelpCenterService.ApiHelpCenterSectionsPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<HelpCenterSectionDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiHelpCenterSectionsPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiHelpCenterSectionsPost$Json(params?: {
    body?: CreateHelpCenterSectionDto
  }): Observable<HelpCenterSectionDtoBaseResponse> {

    return this.apiHelpCenterSectionsPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<HelpCenterSectionDtoBaseResponse>) => r.body as HelpCenterSectionDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiHelpCenterSectionsIdGet
   */
  static readonly ApiHelpCenterSectionsIdGetPath = '/api/HelpCenter/sections/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHelpCenterSectionsIdGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiHelpCenterSectionsIdGet$Plain$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<HelpCenterSectionDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, HelpCenterService.ApiHelpCenterSectionsIdGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<HelpCenterSectionDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiHelpCenterSectionsIdGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiHelpCenterSectionsIdGet$Plain(params: {
    id: number;
  }): Observable<HelpCenterSectionDtoBaseResponse> {

    return this.apiHelpCenterSectionsIdGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<HelpCenterSectionDtoBaseResponse>) => r.body as HelpCenterSectionDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHelpCenterSectionsIdGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiHelpCenterSectionsIdGet$Json$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<HelpCenterSectionDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, HelpCenterService.ApiHelpCenterSectionsIdGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<HelpCenterSectionDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiHelpCenterSectionsIdGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiHelpCenterSectionsIdGet$Json(params: {
    id: number;
  }): Observable<HelpCenterSectionDtoBaseResponse> {

    return this.apiHelpCenterSectionsIdGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<HelpCenterSectionDtoBaseResponse>) => r.body as HelpCenterSectionDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiHelpCenterSectionsIdPut
   */
  static readonly ApiHelpCenterSectionsIdPutPath = '/api/HelpCenter/sections/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHelpCenterSectionsIdPut$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiHelpCenterSectionsIdPut$Plain$Response(params: {
    id: number;
    body?: UpdateHelpCenterSectionDto
  }): Observable<StrictHttpResponse<HelpCenterSectionDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, HelpCenterService.ApiHelpCenterSectionsIdPutPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<HelpCenterSectionDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiHelpCenterSectionsIdPut$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiHelpCenterSectionsIdPut$Plain(params: {
    id: number;
    body?: UpdateHelpCenterSectionDto
  }): Observable<HelpCenterSectionDtoBaseResponse> {

    return this.apiHelpCenterSectionsIdPut$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<HelpCenterSectionDtoBaseResponse>) => r.body as HelpCenterSectionDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHelpCenterSectionsIdPut$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiHelpCenterSectionsIdPut$Json$Response(params: {
    id: number;
    body?: UpdateHelpCenterSectionDto
  }): Observable<StrictHttpResponse<HelpCenterSectionDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, HelpCenterService.ApiHelpCenterSectionsIdPutPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<HelpCenterSectionDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiHelpCenterSectionsIdPut$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiHelpCenterSectionsIdPut$Json(params: {
    id: number;
    body?: UpdateHelpCenterSectionDto
  }): Observable<HelpCenterSectionDtoBaseResponse> {

    return this.apiHelpCenterSectionsIdPut$Json$Response(params).pipe(
      map((r: StrictHttpResponse<HelpCenterSectionDtoBaseResponse>) => r.body as HelpCenterSectionDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiHelpCenterSectionsIdDelete
   */
  static readonly ApiHelpCenterSectionsIdDeletePath = '/api/HelpCenter/sections/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHelpCenterSectionsIdDelete$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiHelpCenterSectionsIdDelete$Plain$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, HelpCenterService.ApiHelpCenterSectionsIdDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiHelpCenterSectionsIdDelete$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiHelpCenterSectionsIdDelete$Plain(params: {
    id: number;
  }): Observable<BooleanBaseResponse> {

    return this.apiHelpCenterSectionsIdDelete$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHelpCenterSectionsIdDelete$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiHelpCenterSectionsIdDelete$Json$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, HelpCenterService.ApiHelpCenterSectionsIdDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiHelpCenterSectionsIdDelete$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiHelpCenterSectionsIdDelete$Json(params: {
    id: number;
  }): Observable<BooleanBaseResponse> {

    return this.apiHelpCenterSectionsIdDelete$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * Path part for operation apiHelpCenterSectionsReorderPost
   */
  static readonly ApiHelpCenterSectionsReorderPostPath = '/api/HelpCenter/sections/reorder';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHelpCenterSectionsReorderPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiHelpCenterSectionsReorderPost$Plain$Response(params?: {
    body?: Array<number>
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, HelpCenterService.ApiHelpCenterSectionsReorderPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiHelpCenterSectionsReorderPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiHelpCenterSectionsReorderPost$Plain(params?: {
    body?: Array<number>
  }): Observable<BooleanBaseResponse> {

    return this.apiHelpCenterSectionsReorderPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHelpCenterSectionsReorderPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiHelpCenterSectionsReorderPost$Json$Response(params?: {
    body?: Array<number>
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, HelpCenterService.ApiHelpCenterSectionsReorderPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiHelpCenterSectionsReorderPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiHelpCenterSectionsReorderPost$Json(params?: {
    body?: Array<number>
  }): Observable<BooleanBaseResponse> {

    return this.apiHelpCenterSectionsReorderPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * Path part for operation apiHelpCenterGuidesGet
   */
  static readonly ApiHelpCenterGuidesGetPath = '/api/HelpCenter/guides';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHelpCenterGuidesGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiHelpCenterGuidesGet$Plain$Response(params?: {
    Query?: string;
    SectionId?: number;
    IsPublished?: boolean;
    Tags?: string;
    Page?: number;
    PageSize?: number;
  }): Observable<StrictHttpResponse<HelpCenterGuideDtoPagedResponse>> {

    const rb = new RequestBuilder(this.rootUrl, HelpCenterService.ApiHelpCenterGuidesGetPath, 'get');
    if (params) {
      rb.query('Query', params.Query, {});
      rb.query('SectionId', params.SectionId, {});
      rb.query('IsPublished', params.IsPublished, {});
      rb.query('Tags', params.Tags, {});
      rb.query('Page', params.Page, {});
      rb.query('PageSize', params.PageSize, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<HelpCenterGuideDtoPagedResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiHelpCenterGuidesGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiHelpCenterGuidesGet$Plain(params?: {
    Query?: string;
    SectionId?: number;
    IsPublished?: boolean;
    Tags?: string;
    Page?: number;
    PageSize?: number;
  }): Observable<HelpCenterGuideDtoPagedResponse> {

    return this.apiHelpCenterGuidesGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<HelpCenterGuideDtoPagedResponse>) => r.body as HelpCenterGuideDtoPagedResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHelpCenterGuidesGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiHelpCenterGuidesGet$Json$Response(params?: {
    Query?: string;
    SectionId?: number;
    IsPublished?: boolean;
    Tags?: string;
    Page?: number;
    PageSize?: number;
  }): Observable<StrictHttpResponse<HelpCenterGuideDtoPagedResponse>> {

    const rb = new RequestBuilder(this.rootUrl, HelpCenterService.ApiHelpCenterGuidesGetPath, 'get');
    if (params) {
      rb.query('Query', params.Query, {});
      rb.query('SectionId', params.SectionId, {});
      rb.query('IsPublished', params.IsPublished, {});
      rb.query('Tags', params.Tags, {});
      rb.query('Page', params.Page, {});
      rb.query('PageSize', params.PageSize, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<HelpCenterGuideDtoPagedResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiHelpCenterGuidesGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiHelpCenterGuidesGet$Json(params?: {
    Query?: string;
    SectionId?: number;
    IsPublished?: boolean;
    Tags?: string;
    Page?: number;
    PageSize?: number;
  }): Observable<HelpCenterGuideDtoPagedResponse> {

    return this.apiHelpCenterGuidesGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<HelpCenterGuideDtoPagedResponse>) => r.body as HelpCenterGuideDtoPagedResponse)
    );
  }

  /**
   * Path part for operation apiHelpCenterGuidesPost
   */
  static readonly ApiHelpCenterGuidesPostPath = '/api/HelpCenter/guides';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHelpCenterGuidesPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiHelpCenterGuidesPost$Plain$Response(params?: {
    body?: CreateHelpCenterGuideDto
  }): Observable<StrictHttpResponse<HelpCenterGuideDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, HelpCenterService.ApiHelpCenterGuidesPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<HelpCenterGuideDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiHelpCenterGuidesPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiHelpCenterGuidesPost$Plain(params?: {
    body?: CreateHelpCenterGuideDto
  }): Observable<HelpCenterGuideDtoBaseResponse> {

    return this.apiHelpCenterGuidesPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<HelpCenterGuideDtoBaseResponse>) => r.body as HelpCenterGuideDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHelpCenterGuidesPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiHelpCenterGuidesPost$Json$Response(params?: {
    body?: CreateHelpCenterGuideDto
  }): Observable<StrictHttpResponse<HelpCenterGuideDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, HelpCenterService.ApiHelpCenterGuidesPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<HelpCenterGuideDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiHelpCenterGuidesPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiHelpCenterGuidesPost$Json(params?: {
    body?: CreateHelpCenterGuideDto
  }): Observable<HelpCenterGuideDtoBaseResponse> {

    return this.apiHelpCenterGuidesPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<HelpCenterGuideDtoBaseResponse>) => r.body as HelpCenterGuideDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiHelpCenterSectionsSectionIdGuidesGet
   */
  static readonly ApiHelpCenterSectionsSectionIdGuidesGetPath = '/api/HelpCenter/sections/{sectionId}/guides';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHelpCenterSectionsSectionIdGuidesGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiHelpCenterSectionsSectionIdGuidesGet$Plain$Response(params: {
    sectionId: number;
  }): Observable<StrictHttpResponse<HelpCenterGuideDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, HelpCenterService.ApiHelpCenterSectionsSectionIdGuidesGetPath, 'get');
    if (params) {
      rb.path('sectionId', params.sectionId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<HelpCenterGuideDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiHelpCenterSectionsSectionIdGuidesGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiHelpCenterSectionsSectionIdGuidesGet$Plain(params: {
    sectionId: number;
  }): Observable<HelpCenterGuideDtoListBaseResponse> {

    return this.apiHelpCenterSectionsSectionIdGuidesGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<HelpCenterGuideDtoListBaseResponse>) => r.body as HelpCenterGuideDtoListBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHelpCenterSectionsSectionIdGuidesGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiHelpCenterSectionsSectionIdGuidesGet$Json$Response(params: {
    sectionId: number;
  }): Observable<StrictHttpResponse<HelpCenterGuideDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, HelpCenterService.ApiHelpCenterSectionsSectionIdGuidesGetPath, 'get');
    if (params) {
      rb.path('sectionId', params.sectionId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<HelpCenterGuideDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiHelpCenterSectionsSectionIdGuidesGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiHelpCenterSectionsSectionIdGuidesGet$Json(params: {
    sectionId: number;
  }): Observable<HelpCenterGuideDtoListBaseResponse> {

    return this.apiHelpCenterSectionsSectionIdGuidesGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<HelpCenterGuideDtoListBaseResponse>) => r.body as HelpCenterGuideDtoListBaseResponse)
    );
  }

  /**
   * Path part for operation apiHelpCenterGuidesFeaturedGet
   */
  static readonly ApiHelpCenterGuidesFeaturedGetPath = '/api/HelpCenter/guides/featured';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHelpCenterGuidesFeaturedGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiHelpCenterGuidesFeaturedGet$Plain$Response(params?: {
    count?: number;
  }): Observable<StrictHttpResponse<HelpCenterGuideDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, HelpCenterService.ApiHelpCenterGuidesFeaturedGetPath, 'get');
    if (params) {
      rb.query('count', params.count, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<HelpCenterGuideDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiHelpCenterGuidesFeaturedGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiHelpCenterGuidesFeaturedGet$Plain(params?: {
    count?: number;
  }): Observable<HelpCenterGuideDtoListBaseResponse> {

    return this.apiHelpCenterGuidesFeaturedGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<HelpCenterGuideDtoListBaseResponse>) => r.body as HelpCenterGuideDtoListBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHelpCenterGuidesFeaturedGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiHelpCenterGuidesFeaturedGet$Json$Response(params?: {
    count?: number;
  }): Observable<StrictHttpResponse<HelpCenterGuideDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, HelpCenterService.ApiHelpCenterGuidesFeaturedGetPath, 'get');
    if (params) {
      rb.query('count', params.count, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<HelpCenterGuideDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiHelpCenterGuidesFeaturedGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiHelpCenterGuidesFeaturedGet$Json(params?: {
    count?: number;
  }): Observable<HelpCenterGuideDtoListBaseResponse> {

    return this.apiHelpCenterGuidesFeaturedGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<HelpCenterGuideDtoListBaseResponse>) => r.body as HelpCenterGuideDtoListBaseResponse)
    );
  }

  /**
   * Path part for operation apiHelpCenterGuidesRecentGet
   */
  static readonly ApiHelpCenterGuidesRecentGetPath = '/api/HelpCenter/guides/recent';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHelpCenterGuidesRecentGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiHelpCenterGuidesRecentGet$Plain$Response(params?: {
    count?: number;
  }): Observable<StrictHttpResponse<HelpCenterGuideDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, HelpCenterService.ApiHelpCenterGuidesRecentGetPath, 'get');
    if (params) {
      rb.query('count', params.count, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<HelpCenterGuideDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiHelpCenterGuidesRecentGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiHelpCenterGuidesRecentGet$Plain(params?: {
    count?: number;
  }): Observable<HelpCenterGuideDtoListBaseResponse> {

    return this.apiHelpCenterGuidesRecentGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<HelpCenterGuideDtoListBaseResponse>) => r.body as HelpCenterGuideDtoListBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHelpCenterGuidesRecentGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiHelpCenterGuidesRecentGet$Json$Response(params?: {
    count?: number;
  }): Observable<StrictHttpResponse<HelpCenterGuideDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, HelpCenterService.ApiHelpCenterGuidesRecentGetPath, 'get');
    if (params) {
      rb.query('count', params.count, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<HelpCenterGuideDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiHelpCenterGuidesRecentGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiHelpCenterGuidesRecentGet$Json(params?: {
    count?: number;
  }): Observable<HelpCenterGuideDtoListBaseResponse> {

    return this.apiHelpCenterGuidesRecentGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<HelpCenterGuideDtoListBaseResponse>) => r.body as HelpCenterGuideDtoListBaseResponse)
    );
  }

  /**
   * Path part for operation apiHelpCenterGuidesSearchGet
   */
  static readonly ApiHelpCenterGuidesSearchGetPath = '/api/HelpCenter/guides/search';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHelpCenterGuidesSearchGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiHelpCenterGuidesSearchGet$Plain$Response(params?: {
    query?: string;
    sectionId?: number;
  }): Observable<StrictHttpResponse<HelpCenterGuideDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, HelpCenterService.ApiHelpCenterGuidesSearchGetPath, 'get');
    if (params) {
      rb.query('query', params.query, {});
      rb.query('sectionId', params.sectionId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<HelpCenterGuideDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiHelpCenterGuidesSearchGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiHelpCenterGuidesSearchGet$Plain(params?: {
    query?: string;
    sectionId?: number;
  }): Observable<HelpCenterGuideDtoListBaseResponse> {

    return this.apiHelpCenterGuidesSearchGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<HelpCenterGuideDtoListBaseResponse>) => r.body as HelpCenterGuideDtoListBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHelpCenterGuidesSearchGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiHelpCenterGuidesSearchGet$Json$Response(params?: {
    query?: string;
    sectionId?: number;
  }): Observable<StrictHttpResponse<HelpCenterGuideDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, HelpCenterService.ApiHelpCenterGuidesSearchGetPath, 'get');
    if (params) {
      rb.query('query', params.query, {});
      rb.query('sectionId', params.sectionId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<HelpCenterGuideDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiHelpCenterGuidesSearchGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiHelpCenterGuidesSearchGet$Json(params?: {
    query?: string;
    sectionId?: number;
  }): Observable<HelpCenterGuideDtoListBaseResponse> {

    return this.apiHelpCenterGuidesSearchGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<HelpCenterGuideDtoListBaseResponse>) => r.body as HelpCenterGuideDtoListBaseResponse)
    );
  }

  /**
   * Path part for operation apiHelpCenterGuidesIdGet
   */
  static readonly ApiHelpCenterGuidesIdGetPath = '/api/HelpCenter/guides/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHelpCenterGuidesIdGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiHelpCenterGuidesIdGet$Plain$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<HelpCenterGuideDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, HelpCenterService.ApiHelpCenterGuidesIdGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<HelpCenterGuideDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiHelpCenterGuidesIdGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiHelpCenterGuidesIdGet$Plain(params: {
    id: number;
  }): Observable<HelpCenterGuideDtoBaseResponse> {

    return this.apiHelpCenterGuidesIdGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<HelpCenterGuideDtoBaseResponse>) => r.body as HelpCenterGuideDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHelpCenterGuidesIdGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiHelpCenterGuidesIdGet$Json$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<HelpCenterGuideDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, HelpCenterService.ApiHelpCenterGuidesIdGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<HelpCenterGuideDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiHelpCenterGuidesIdGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiHelpCenterGuidesIdGet$Json(params: {
    id: number;
  }): Observable<HelpCenterGuideDtoBaseResponse> {

    return this.apiHelpCenterGuidesIdGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<HelpCenterGuideDtoBaseResponse>) => r.body as HelpCenterGuideDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiHelpCenterGuidesIdPut
   */
  static readonly ApiHelpCenterGuidesIdPutPath = '/api/HelpCenter/guides/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHelpCenterGuidesIdPut$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiHelpCenterGuidesIdPut$Plain$Response(params: {
    id: number;
    body?: UpdateHelpCenterGuideDto
  }): Observable<StrictHttpResponse<HelpCenterGuideDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, HelpCenterService.ApiHelpCenterGuidesIdPutPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<HelpCenterGuideDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiHelpCenterGuidesIdPut$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiHelpCenterGuidesIdPut$Plain(params: {
    id: number;
    body?: UpdateHelpCenterGuideDto
  }): Observable<HelpCenterGuideDtoBaseResponse> {

    return this.apiHelpCenterGuidesIdPut$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<HelpCenterGuideDtoBaseResponse>) => r.body as HelpCenterGuideDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHelpCenterGuidesIdPut$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiHelpCenterGuidesIdPut$Json$Response(params: {
    id: number;
    body?: UpdateHelpCenterGuideDto
  }): Observable<StrictHttpResponse<HelpCenterGuideDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, HelpCenterService.ApiHelpCenterGuidesIdPutPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<HelpCenterGuideDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiHelpCenterGuidesIdPut$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiHelpCenterGuidesIdPut$Json(params: {
    id: number;
    body?: UpdateHelpCenterGuideDto
  }): Observable<HelpCenterGuideDtoBaseResponse> {

    return this.apiHelpCenterGuidesIdPut$Json$Response(params).pipe(
      map((r: StrictHttpResponse<HelpCenterGuideDtoBaseResponse>) => r.body as HelpCenterGuideDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiHelpCenterGuidesIdDelete
   */
  static readonly ApiHelpCenterGuidesIdDeletePath = '/api/HelpCenter/guides/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHelpCenterGuidesIdDelete$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiHelpCenterGuidesIdDelete$Plain$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, HelpCenterService.ApiHelpCenterGuidesIdDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiHelpCenterGuidesIdDelete$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiHelpCenterGuidesIdDelete$Plain(params: {
    id: number;
  }): Observable<BooleanBaseResponse> {

    return this.apiHelpCenterGuidesIdDelete$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHelpCenterGuidesIdDelete$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiHelpCenterGuidesIdDelete$Json$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, HelpCenterService.ApiHelpCenterGuidesIdDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiHelpCenterGuidesIdDelete$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiHelpCenterGuidesIdDelete$Json(params: {
    id: number;
  }): Observable<BooleanBaseResponse> {

    return this.apiHelpCenterGuidesIdDelete$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * Path part for operation apiHelpCenterGuidesSlugSlugGet
   */
  static readonly ApiHelpCenterGuidesSlugSlugGetPath = '/api/HelpCenter/guides/slug/{slug}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHelpCenterGuidesSlugSlugGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiHelpCenterGuidesSlugSlugGet$Plain$Response(params: {
    slug: string;
  }): Observable<StrictHttpResponse<HelpCenterGuideDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, HelpCenterService.ApiHelpCenterGuidesSlugSlugGetPath, 'get');
    if (params) {
      rb.path('slug', params.slug, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<HelpCenterGuideDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiHelpCenterGuidesSlugSlugGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiHelpCenterGuidesSlugSlugGet$Plain(params: {
    slug: string;
  }): Observable<HelpCenterGuideDtoBaseResponse> {

    return this.apiHelpCenterGuidesSlugSlugGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<HelpCenterGuideDtoBaseResponse>) => r.body as HelpCenterGuideDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHelpCenterGuidesSlugSlugGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiHelpCenterGuidesSlugSlugGet$Json$Response(params: {
    slug: string;
  }): Observable<StrictHttpResponse<HelpCenterGuideDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, HelpCenterService.ApiHelpCenterGuidesSlugSlugGetPath, 'get');
    if (params) {
      rb.path('slug', params.slug, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<HelpCenterGuideDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiHelpCenterGuidesSlugSlugGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiHelpCenterGuidesSlugSlugGet$Json(params: {
    slug: string;
  }): Observable<HelpCenterGuideDtoBaseResponse> {

    return this.apiHelpCenterGuidesSlugSlugGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<HelpCenterGuideDtoBaseResponse>) => r.body as HelpCenterGuideDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiHelpCenterGuidesIdPublishPost
   */
  static readonly ApiHelpCenterGuidesIdPublishPostPath = '/api/HelpCenter/guides/{id}/publish';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHelpCenterGuidesIdPublishPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiHelpCenterGuidesIdPublishPost$Plain$Response(params: {
    id: number;
    body?: boolean
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, HelpCenterService.ApiHelpCenterGuidesIdPublishPostPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiHelpCenterGuidesIdPublishPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiHelpCenterGuidesIdPublishPost$Plain(params: {
    id: number;
    body?: boolean
  }): Observable<BooleanBaseResponse> {

    return this.apiHelpCenterGuidesIdPublishPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHelpCenterGuidesIdPublishPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiHelpCenterGuidesIdPublishPost$Json$Response(params: {
    id: number;
    body?: boolean
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, HelpCenterService.ApiHelpCenterGuidesIdPublishPostPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiHelpCenterGuidesIdPublishPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiHelpCenterGuidesIdPublishPost$Json(params: {
    id: number;
    body?: boolean
  }): Observable<BooleanBaseResponse> {

    return this.apiHelpCenterGuidesIdPublishPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * Path part for operation apiHelpCenterGuidesReorderPost
   */
  static readonly ApiHelpCenterGuidesReorderPostPath = '/api/HelpCenter/guides/reorder';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHelpCenterGuidesReorderPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiHelpCenterGuidesReorderPost$Plain$Response(params?: {
    body?: Array<number>
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, HelpCenterService.ApiHelpCenterGuidesReorderPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiHelpCenterGuidesReorderPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiHelpCenterGuidesReorderPost$Plain(params?: {
    body?: Array<number>
  }): Observable<BooleanBaseResponse> {

    return this.apiHelpCenterGuidesReorderPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHelpCenterGuidesReorderPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiHelpCenterGuidesReorderPost$Json$Response(params?: {
    body?: Array<number>
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, HelpCenterService.ApiHelpCenterGuidesReorderPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiHelpCenterGuidesReorderPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiHelpCenterGuidesReorderPost$Json(params?: {
    body?: Array<number>
  }): Observable<BooleanBaseResponse> {

    return this.apiHelpCenterGuidesReorderPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * Path part for operation apiHelpCenterTagsGet
   */
  static readonly ApiHelpCenterTagsGetPath = '/api/HelpCenter/tags';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHelpCenterTagsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiHelpCenterTagsGet$Plain$Response(params?: {
  }): Observable<StrictHttpResponse<StringListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, HelpCenterService.ApiHelpCenterTagsGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<StringListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiHelpCenterTagsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiHelpCenterTagsGet$Plain(params?: {
  }): Observable<StringListBaseResponse> {

    return this.apiHelpCenterTagsGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<StringListBaseResponse>) => r.body as StringListBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHelpCenterTagsGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiHelpCenterTagsGet$Json$Response(params?: {
  }): Observable<StrictHttpResponse<StringListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, HelpCenterService.ApiHelpCenterTagsGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<StringListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiHelpCenterTagsGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiHelpCenterTagsGet$Json(params?: {
  }): Observable<StringListBaseResponse> {

    return this.apiHelpCenterTagsGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<StringListBaseResponse>) => r.body as StringListBaseResponse)
    );
  }

  /**
   * Path part for operation apiHelpCenterGuidesGuideIdAttachmentsGet
   */
  static readonly ApiHelpCenterGuidesGuideIdAttachmentsGetPath = '/api/HelpCenter/guides/{guideId}/attachments';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHelpCenterGuidesGuideIdAttachmentsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiHelpCenterGuidesGuideIdAttachmentsGet$Plain$Response(params: {
    guideId: number;
  }): Observable<StrictHttpResponse<HelpCenterAttachmentDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, HelpCenterService.ApiHelpCenterGuidesGuideIdAttachmentsGetPath, 'get');
    if (params) {
      rb.path('guideId', params.guideId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<HelpCenterAttachmentDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiHelpCenterGuidesGuideIdAttachmentsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiHelpCenterGuidesGuideIdAttachmentsGet$Plain(params: {
    guideId: number;
  }): Observable<HelpCenterAttachmentDtoListBaseResponse> {

    return this.apiHelpCenterGuidesGuideIdAttachmentsGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<HelpCenterAttachmentDtoListBaseResponse>) => r.body as HelpCenterAttachmentDtoListBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHelpCenterGuidesGuideIdAttachmentsGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiHelpCenterGuidesGuideIdAttachmentsGet$Json$Response(params: {
    guideId: number;
  }): Observable<StrictHttpResponse<HelpCenterAttachmentDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, HelpCenterService.ApiHelpCenterGuidesGuideIdAttachmentsGetPath, 'get');
    if (params) {
      rb.path('guideId', params.guideId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<HelpCenterAttachmentDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiHelpCenterGuidesGuideIdAttachmentsGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiHelpCenterGuidesGuideIdAttachmentsGet$Json(params: {
    guideId: number;
  }): Observable<HelpCenterAttachmentDtoListBaseResponse> {

    return this.apiHelpCenterGuidesGuideIdAttachmentsGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<HelpCenterAttachmentDtoListBaseResponse>) => r.body as HelpCenterAttachmentDtoListBaseResponse)
    );
  }

  /**
   * Path part for operation apiHelpCenterGuidesGuideIdAttachmentsPost
   */
  static readonly ApiHelpCenterGuidesGuideIdAttachmentsPostPath = '/api/HelpCenter/guides/{guideId}/attachments';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHelpCenterGuidesGuideIdAttachmentsPost$Plain()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiHelpCenterGuidesGuideIdAttachmentsPost$Plain$Response(params: {
    guideId: number;
    body?: { 'ContentType'?: string, 'ContentDisposition'?: string, 'Headers'?: { [key: string]: Array<string> }, 'Length'?: number, 'Name'?: string, 'FileName'?: string, 'altText'?: string }
  }): Observable<StrictHttpResponse<HelpCenterAttachmentDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, HelpCenterService.ApiHelpCenterGuidesGuideIdAttachmentsPostPath, 'post');
    if (params) {
      rb.path('guideId', params.guideId, {});
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<HelpCenterAttachmentDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiHelpCenterGuidesGuideIdAttachmentsPost$Plain$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiHelpCenterGuidesGuideIdAttachmentsPost$Plain(params: {
    guideId: number;
    body?: { 'ContentType'?: string, 'ContentDisposition'?: string, 'Headers'?: { [key: string]: Array<string> }, 'Length'?: number, 'Name'?: string, 'FileName'?: string, 'altText'?: string }
  }): Observable<HelpCenterAttachmentDtoBaseResponse> {

    return this.apiHelpCenterGuidesGuideIdAttachmentsPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<HelpCenterAttachmentDtoBaseResponse>) => r.body as HelpCenterAttachmentDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHelpCenterGuidesGuideIdAttachmentsPost$Json()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiHelpCenterGuidesGuideIdAttachmentsPost$Json$Response(params: {
    guideId: number;
    body?: { 'ContentType'?: string, 'ContentDisposition'?: string, 'Headers'?: { [key: string]: Array<string> }, 'Length'?: number, 'Name'?: string, 'FileName'?: string, 'altText'?: string }
  }): Observable<StrictHttpResponse<HelpCenterAttachmentDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, HelpCenterService.ApiHelpCenterGuidesGuideIdAttachmentsPostPath, 'post');
    if (params) {
      rb.path('guideId', params.guideId, {});
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<HelpCenterAttachmentDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiHelpCenterGuidesGuideIdAttachmentsPost$Json$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiHelpCenterGuidesGuideIdAttachmentsPost$Json(params: {
    guideId: number;
    body?: { 'ContentType'?: string, 'ContentDisposition'?: string, 'Headers'?: { [key: string]: Array<string> }, 'Length'?: number, 'Name'?: string, 'FileName'?: string, 'altText'?: string }
  }): Observable<HelpCenterAttachmentDtoBaseResponse> {

    return this.apiHelpCenterGuidesGuideIdAttachmentsPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<HelpCenterAttachmentDtoBaseResponse>) => r.body as HelpCenterAttachmentDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiHelpCenterAttachmentsIdDownloadGet
   */
  static readonly ApiHelpCenterAttachmentsIdDownloadGetPath = '/api/HelpCenter/attachments/{id}/download';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHelpCenterAttachmentsIdDownloadGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiHelpCenterAttachmentsIdDownloadGet$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, HelpCenterService.ApiHelpCenterAttachmentsIdDownloadGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiHelpCenterAttachmentsIdDownloadGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiHelpCenterAttachmentsIdDownloadGet(params: {
    id: number;
  }): Observable<void> {

    return this.apiHelpCenterAttachmentsIdDownloadGet$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation apiHelpCenterAttachmentsIdDelete
   */
  static readonly ApiHelpCenterAttachmentsIdDeletePath = '/api/HelpCenter/attachments/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHelpCenterAttachmentsIdDelete$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiHelpCenterAttachmentsIdDelete$Plain$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, HelpCenterService.ApiHelpCenterAttachmentsIdDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiHelpCenterAttachmentsIdDelete$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiHelpCenterAttachmentsIdDelete$Plain(params: {
    id: number;
  }): Observable<BooleanBaseResponse> {

    return this.apiHelpCenterAttachmentsIdDelete$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHelpCenterAttachmentsIdDelete$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiHelpCenterAttachmentsIdDelete$Json$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, HelpCenterService.ApiHelpCenterAttachmentsIdDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiHelpCenterAttachmentsIdDelete$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiHelpCenterAttachmentsIdDelete$Json(params: {
    id: number;
  }): Observable<BooleanBaseResponse> {

    return this.apiHelpCenterAttachmentsIdDelete$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

}
